export const buildNumber = '20260518.7';
export const version = '3.13.0';
export const latestCommit = '1009ced9125f2357ace452c223c173fd824397f5';
